export const initialFormValues = {
    id: -1,
    nombre: '',
    descripcion: '',
    idTipoTributo: 0,
    idEstadoProcedimiento: 0,
    idUsuarioCreacion: 0,
    fechaCreacion: null,
}

export const initialOtherValues = {
    archivos: [],
    observaciones: [],
    etiquetas: [],
    procedimientoFiltros: [],
    procedimientoParametros: [],
    procedimientoVariables: [],
}

 

    